
import {Vue, Component, Prop} from 'vue-property-decorator';
import {OrderParty} from "@/models/api/orders/get";
import {MAP_STYLES} from "@/consts";
import {OrderModule} from "@/store/modules";
import {getModule} from "vuex-module-decorators";
import notifications from "@/lib/notifications";

const orderModule = getModule(OrderModule);


const defaultContact: OrderParty = {
  address: {
    city: "",
    state: "",
    streetLine1: "",
    streetLine2: "",
    zip: ""
  },
  id: "",
  location: null,
  name: "",
  emailAddress: "",
  phoneType: "",
  phoneNumber: "",
  primaryPhone: "",
  secondaryPhone: null,
  standardizedAddress: null,
  agentId: null,
  displayId: null
};

@Component({
  name: 'AddressWidgetGeocodeModal',
  data() {
    return {
      customBus: new Vue()
    }
  }
})
export default class AddressWidgetGeocodeModal extends Vue {
  visible: boolean = false;
  showGeocodeButton: boolean = true;
  showDragActions: boolean = false;
  dragLat: number = 0;
  dragLng: number = 0;
  showCoordinateEdit: boolean = false;
  editLat: number = 0;
  editLng: number = 0;

  @Prop({default: defaultContact})
  contact: OrderParty;

  @Prop({default: ""})
  type: string;

  async saveEditCoordinate() {
    const result = await orderModule.updateCompanyCoordinates({
      latitude: this.editLat,
      longitude: this.editLng,
      id: this.contact.id,
      type: this.type,
    });

    if (result.data.isSuccess === true) {
      this.resetMarker();
      this.showCoordinateEdit = false;
      this.editLat = 0;
      this.editLng = 0;
      notifications.success("Coordinate update successful", "Coordinate update successful.");
    } else {
      notifications.error("Update failed", "Coordinate update failed. Please try again.");
    }
  }

  coordinateEdit() {
    this.showCoordinateEdit = true;
    this.editLat = this.getCurrentLat();
    this.editLng = this.getCurrentLong();
  }

  getCurrentLong() : any {
    if (this.dragLng === 0) {
      const valueToParse = this.contact.location === undefined || this.contact.location === null ? 0 : this.contact.location.longitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLng.toString()).toFixed(5);
  }

  getCurrentLat() : any {
    if (this.dragLat === 0) {
      const valueToParse = this.contact.location === undefined || this.contact.location === null ? 0 : this.contact.location.latitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLat.toString()).toFixed(5);
  }

  cancel() {
    this.visible = false;
  }

  async updateCoordinates() {
    const result = await orderModule.updateCompanyCoordinates({
      latitude: this.dragLat,
      longitude: this.dragLng,
      id: this.contact.id,
      type: this.type,
      orderHeader: orderModule.currentOrder.headerNumber
    })

    if (result.data.isSuccess === true) {
      this.resetMarker();
      notifications.success("Coordinate update successful", "Coordinate update successful.");
    } else {
      notifications.error("Update failed", "Coordinate update failed. Please try again.");
    }
  }

  async geoCodeAddress() {
    const result = await orderModule.geoCodeAddress({
      contact: this.contact,
      type: this.type,
      orderHeader: orderModule.currentOrder.headerNumber
    });

    if (result.data.isSuccess === true) {
      notifications.success("Geocode Successful", "Geocode successful.");
    } else {
      notifications.error("Geocode Failed", "Geocode failed. Please try again.");
    }
  }

  resetMarker() {
    this.dragLat = 0;
    this.dragLng = 0;
    this.showDragActions = false;
    this.showGeocodeButton = true;
  }

  dragEnd(event) {
    this.dragLat = event.latLng.lat();
    this.dragLng = event.latLng.lng();
    if(this.showCoordinateEdit === true){
      this.editLat = Number(parseFloat(event.latLng.lat()).toFixed(5));
      this.editLng = Number(parseFloat(event.latLng.lng()).toFixed(5));
    }
    this.showGeocodeButton = false;
    this.showDragActions = true;
  }

  mapCenter() {
    if (this.contact.location === undefined || this.contact.location === null) return {lat: 0, lng: 0}
    return {lat: this.contact.location.latitude, lng: this.contact.location.longitude};
  }

  mapCoordinates() {
    if (this.contact.location === undefined ||  this.contact.location === null) return {lat: 0, lng: 0}
    if (this.dragLat !== 0 && this.dragLng !== 0) return {lat: this.dragLat, lng: this.dragLng};
    return {lat: this.contact.location.latitude, lng: this.contact.location.longitude};
  }

  async show() {
    if(this.contact.location === undefined || this.contact.location === null || (this.contact.location.latitude === 0 && this.contact.location.longitude === 0)){
      await orderModule.getZipCodeCoordinates({
        zipCode: this.contact.address.zip,
        type: this.type
      });
    }
    this.visible = true;
  }

  mapOptions() {
    return MAP_STYLES;
  }
}
